import { WEB_ROUTE_PATHS } from 'shared/src/webRoutePaths';

export const SOCIAL_PROVIDERS = ['kakao', 'naver', 'facebook', 'apple'] as const;
export type SocialProvider = (typeof SOCIAL_PROVIDERS)[number];

export const isSocialProvider = (value: string): value is SocialProvider =>
  (SOCIAL_PROVIDERS as readonly string[]).includes(value);

const KAKAO_JS_KEY = '5cb976022f1ca7bfa5b6d8585a5f1363';
const KAKAO_AUTHORIZE_URL = 'https://kauth.kakao.com/oauth/authorize';

const NAVER_CLIENT_ID = 'GitBxf2cNUah9RGEQ_Ik';
const NAVER_AUTHORIZE_URL = 'https://nid.naver.com/oauth2.0/authorize';

const FACEBOOK_APP_ID = '626762010758908';
const FACEBOOK_AUTHORIZE_URL = 'https://www.facebook.com/v15.0/dialog/oauth';

const APPLE_CLIENT_ID = 'com.ablycorp.web';
const APPLE_AUTHORIZE_URL = 'https://appleid.apple.com/auth/authorize';

/** authorize 요청과 (카카오) 코드 교환 요청의 redirect_uri는 반드시 동일해야 한다. */
export const getAuthCallbackUri = (provider: SocialProvider) =>
  `${window.location.origin}${WEB_ROUTE_PATHS.AuthCallback.replace(':provider', provider)}`;

/** 로그인 성공 후 복귀할 경로(/login?redirect=)를 OAuth state로 실어 보낸다. */
const getRedirectState = () =>
  new URLSearchParams(window.location.search).get('redirect') ?? '/';

// 아래 start 함수들은 전부 웹 한정 — Login 화면에서 isWeb 가드 후 호출한다.
// 각 provider SDK가 만드는 authorize URL과 동일한 형태를 SDK 로드 없이 직접 구성하며,
// 콜백은 /auth/:provider(AuthCallback 화면)가 처리한다.

export const startKakaoLogin = () => {
  const url = new URL(KAKAO_AUTHORIZE_URL);
  url.searchParams.set('client_id', KAKAO_JS_KEY);
  url.searchParams.set('redirect_uri', getAuthCallbackUri('kakao'));
  url.searchParams.set('response_type', 'code');
  url.searchParams.set('state', getRedirectState());
  window.location.href = url.toString();
};

export const startNaverLogin = () => {
  const url = new URL(NAVER_AUTHORIZE_URL);
  url.searchParams.set('response_type', 'token');
  url.searchParams.set('client_id', NAVER_CLIENT_ID);
  url.searchParams.set('redirect_uri', getAuthCallbackUri('naver'));
  // 네이버는 state가 필수 파라미터.
  url.searchParams.set('state', getRedirectState());
  window.location.href = url.toString();
};

export const startFacebookLogin = () => {
  const url = new URL(FACEBOOK_AUTHORIZE_URL);
  url.searchParams.set('client_id', FACEBOOK_APP_ID);
  url.searchParams.set('redirect_uri', getAuthCallbackUri('facebook'));
  url.searchParams.set('response_type', 'token');
  url.searchParams.set('scope', 'public_profile,email');
  url.searchParams.set('auth_type', 'rerequest');
  url.searchParams.set('state', getRedirectState());
  window.location.href = url.toString();
};

export const startAppleLogin = () => {
  const url = new URL(APPLE_AUTHORIZE_URL);
  url.searchParams.set('client_id', APPLE_CLIENT_ID);
  url.searchParams.set('redirect_uri', getAuthCallbackUri('apple'));
  // scope를 요청하면 애플이 form_post(서버 수신)를 강제해 fragment를 쓸 수 없다.
  url.searchParams.set('response_type', 'code id_token');
  url.searchParams.set('response_mode', 'fragment');
  url.searchParams.set('state', getRedirectState());
  // URLSearchParams는 공백을 +로 직렬화하는데 애플 authorize는 %20 표기를 쓴다.
  window.location.href = url.toString().replace(/\+/g, '%20');
};
